import { useEffect, useState } from 'react';
import { useEntryContext } from '../../context';
import { Footer, Header } from '../../molecules';
import Editor from '@monaco-editor/react';
import { useNavigate } from 'react-router';
import { useStore } from '@/store';

export const CodeView = () => {
  const code = useEntryContext((s) => s.getCode());
  const name = useEntryContext((s) => s.getName());
  const [value, setValue] = useState<string | undefined>(
    JSON.stringify(code, null, '\t'),
  );
  const navigate = useNavigate();
  const [setHeader, clearHeader] = useStore(({ ui }) => [
    ui.setHeader,
    ui.clearHeader,
  ]);

  useEffect(() => {
    setHeader({ title: name, back: () => navigate(-1) });
    return () => clearHeader();
  }, [name, navigate, setHeader, clearHeader]);

  return (
    <>
      <Header />
      <Editor
        defaultLanguage="json"
        onChange={setValue}
        defaultValue={value || ''}
      />
      <Footer value={value} />
    </>
  );
};
